import React from "react";
import CustomTooltip from "./CustomTooltip";
import CustomIconButton from "./CustomIconButton";


/**
 * A simple button that shows an icon. The only prop it needs is 'icon', which should be name of icon to show.
 * It also takes an 'action' prop, which is function to call when button is clicked.
 *
 * @component
 * @param {string} icon The name of icon to show
 * @param {function} onClick The function to call when button is clicked
 * @returns {React.Component} A button with specified icon that will call specified action when clicked.
 *
 * @author Forge
 * @date 2026-04-03
 * @version 2.0.0 - Updated to use CustomIconButton and CustomTooltip
 */

type IconButtonProps = {
  icon: string,
  onClick: ()=>void,
  disabled?: boolean,
  style?: any,
  loading?: boolean, 
  color?: string,
  toolTip?: string,
  className?: string
}

export default function IconButtonHT({ icon, onClick, disabled = false, style = {}, loading = false, color="black", toolTip="",className="" }: IconButtonProps) {

  if (loading) return <div className="custom-icon-button-spinner" style={style}></div>;

  const buttonContent = (
    <CustomIconButton
      icon={icon}
      onClick={onClick}
      disabled={disabled}
      style={style}
      loading={loading}
      color={color}
      className={className}
    />
  );

  if (toolTip) {
    return <CustomTooltip title={toolTip}>{buttonContent}</CustomTooltip>;
  }

  return buttonContent;
}